<div class="notification-panel">
  <!-- Header -->
  <div class="notification-panel__header">
    <h3>Notifications</h3>
    <span class="notification-panel__badge" *ngIf="unreadCount > 0">
      {{ unreadCount }} new
    </span>
  </div>

  <!-- List -->
  <div class="notification-panel__body">
    <div
      *ngFor="let notification of notifications"
      class="notification-item"
      [class.notification-item--unread]="!notification.read"
      [class.notification-item--success]="notification.type === 'success'"
      [class.notification-item--warning]="notification.type === 'warning'"
      [class.notification-item--error]="notification.type === 'error'"
      (click)="onNotificationClick($event, notification)">
      <div class="notification-item__icon">
        <mat-icon>{{ getNotificationIcon(notification.type) }}</mat-icon>
      </div>
      <div class="notification-item__content">
        <div class="notification-item__title">{{ notification.title }}</div>
        <div class="notification-item__message">{{ notification.message }}</div>
        <div class="notification-item__time">
          {{ getRelativeTime(notification.timestamp) }}
        </div>
      </div>
      <div
        class="notification-item__indicator"
        *ngIf="!notification.read"></div>
    </div>

    <!-- Empty State -->
    <div class="notification-panel__empty" *ngIf="notifications.length === 0">
      <mat-icon>notifications_none</mat-icon>
      <p>No notifications</p>
    </div>
  </div>

  <!-- Footer -->
  <div class="notification-panel__footer" *ngIf="notifications.length > 0">
    <button mat-button color="primary" (click)="onClearAll($event)">
      Clear All
    </button>
  </div>
</div>
